export default {backendUrl: 'http://junk.tagirshine.me:8080'}
// export default {backendUrl: 'http://localhost:8080'}


